/*
 * Whether an error is a page's code failing to load. Each page, and much of what a page opens, is
 * its own chunk, fetched the first time it is wanted. A tab opened before a deploy asks for the
 * chunks it was built with; once a deploy has replaced them, or the network is gone, that fetch
 * fails, and each browser says so in its own words. Beacon treats it as a release having landed
 * ("Beacon has been updated", with Reload), never as a page that broke.
 */

/** What each browser says, and what Vite's preloading says, when a chunk doesn't arrive. */
const chunkFailures = [
  // Chrome, Edge and the other Chromium browsers.
  /Failed to fetch dynamically imported module/i,
  // Safari.
  /Importing a module script failed/i,
  // Firefox.
  /error loading dynamically imported module/i,
  // Vite, for the stylesheet a chunk brings with it.
  /Unable to preload CSS/i,
]

/** Whether `error` (anything thrown) is a chunk of the web app's code that didn't load. */
export function isChunkLoadError(error: unknown) {
  const message = error instanceof Error ? error.message : typeof error === "string" ? error : ""
  return chunkFailures.some((failure) => failure.test(message))
}
